module.exports = __webpack_public_path__ + "img/600.e3a90bb8.jpg";